import { ErrorBoundary } from "@/components/shared/ErrorBoundary";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import "./styles/main.css";

history.scrollRestoration = "manual";
window.scrollTo(0, 0);

if ("serviceWorker" in navigator) {
  // Remove the previously shipped PWA worker for returning visitors.
  void navigator.serviceWorker
    .getRegistrations()
    .then(async (registrations) => {
      const legacy = registrations.filter((registration) =>
        [
          registration.active,
          registration.waiting,
          registration.installing,
        ].some(
          (worker) => worker && new URL(worker.scriptURL).pathname === "/sw.js",
        ),
      );
      if (legacy.length === 0) return;
      await Promise.all(
        legacy.map((registration) => registration.unregister()),
      );
      if ("caches" in window) await caches.delete("pw-cache-v2");
      if (
        navigator.serviceWorker.controller &&
        new URL(navigator.serviceWorker.controller.scriptURL).pathname ===
          "/sw.js"
      ) {
        window.location.reload();
      }
    })
    .catch(() => {});
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
